'use client';

import { useMemo } from 'react';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';

const useSubAccountKeys = (): string[] => {
	const accounts = useVelocityAccountStore((s) => s.accounts);

	const accountKeys = useMemo(() => {
		return Object.values(accounts).map((account) => account?.userKey ?? '');
	}, [Object.keys(accounts).join(',')]);

	return accountKeys;
};

export default useSubAccountKeys;
